import { render, staticRenderFns } from "./HighSpeedRunningChart.vue?vue&type=template&id=72f1fde6"
import script from "./HighSpeedRunningChart.vue?vue&type=script&lang=js"
export * from "./HighSpeedRunningChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports